import React, { useState } from 'react';
import { node, string, bool } from 'prop-types';
import classNames from 'classnames';
import { Icon } from '../../components';

import css from './SettingsAccordion.module.css';

/**
 * Reusable expandable card for the Settings pages.
 * Header: title (left) + optional badge (left, beside title) + chevron (right).
 * Body: any children, hidden when collapsed.
 *
 * Used for Subscription, Payout Account, and Payout History panels — and
 * later for Org Settings too.
 */
const SettingsAccordion = props => {
  const { className, title, badge, defaultOpen, children } = props;

  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <section className={classNames(css.root, className)}>
      <button
        type="button"
        className={css.header}
        onClick={() => setIsOpen(o => !o)}
        aria-expanded={isOpen}
      >
        <div className={css.heading}>
          <span className={css.title}>{title}</span>
          {badge ? <span className={css.badgeSlot}>{badge}</span> : null}
        </div>
        <Icon
          name="chevronDown"
          className={classNames(css.chevron, { [css.chevronOpen]: isOpen })}
        />
      </button>

      {isOpen ? <div className={css.body}>{children}</div> : null}
    </section>
  );
};

SettingsAccordion.defaultProps = {
  className: null,
  badge: null,
  defaultOpen: true,
};

SettingsAccordion.propTypes = {
  className: string,
  title: node.isRequired,
  badge: node,
  defaultOpen: bool,
  children: node,
};

export default SettingsAccordion;
